import React from "react";
import "./About.scss";

const About = () => {
  return (
    <div className="about">
      <h1>About</h1>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Quibusdam
        laudantium nostrum voluptate consequuntur quia, hic ipsum voluptates
        repellendus earum voluptatum! Cum sed aperiam doloribus consequatur
        tempora harum, nobis aliquid accusantium, sint reprehenderit repellat
        necessitatibus asperiores provident iure, molestiae molestias laborum.
        Aliquid autem at adipisci repudiandae labore ab iste assumenda hic.
      </p>
    </div>
  );
};

export default About;
